export default __webpack_public_path__ + "static/media/weatherdashboard.2ed07c27.png";